/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useRef, useState } from "react";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { INTEGRATION_TYPE } from "@/app/csr-src/apis/checkout/constants/constants";

import UKToast from "@/common-components-src/components/UKToast/index";;
import { Button } from "@mui/material";

import Styles from "./btn.module.scss";
interface CreditCardPayProps {
  onSubmit: () => any; // 获取支付信息
  toOrderList: () => void; // 支付失败后的回调
}

const CreditCardPay: FC<CreditCardPayProps> = observer((props) => {
  const { t } = useTranslation();

  const { checkoutStore } = useStores();
  const { creditCardStore } = checkoutStore;

  const [loading, setLoading] = useState(false);

  // 关闭loading
  const closeLoading = () => {
    setTimeout(() => {
      setLoading(false);
      checkoutStore.setSafetyLoading(false);
    }, 500);
  };

  // 关闭loading
  const onPayError = () => {
    UKToast.show({
      content: t("common.message.networkError"), // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
    closeLoading();
    props.toOrderList(); // 支付失败，跳转到订单列表
  };
  const handleSubmitOrder = async () => {

    // 校验BNP信用卡表单是否校验通过
    if (!checkoutStore.isQuickPay
      && checkoutStore.isBnpCreditCardForm
      && !creditCardStore.validateForm()) {
      closeLoading();
      return;
    }

    setLoading(true);
    checkoutStore.setSafetyLoading(true);

    const res: any = await props.onSubmit();

    if (!res.success) {
      closeLoading();
      return;
    }

    console.log("res.success", res, res?.success);

    let data: any = {};

    try {
      data = JSON.parse(res.data.payInfo);
    } catch (error) {
      // 报错， 跳转订单列表
      onPayError();
      return;
    }

   

    const url = data.httpUrl;

    if (checkoutStore.isQuickPay) {
      // 如果是快速支付，则直接成功页面
      if (!url) {
        onPayError();
        return;
      }
      toPay(url);
      return
    }
    let obj: any = {};
    let payload: any = {};

    if (checkoutStore.isBnpCreditCardForm) {
      payload = data.payload ? JSON.parse(data.payload) : {};
      obj = {
        url: payload.actionUrl || "",
        params: {
          Data: payload.data || "",
          MerchantID: payload.merchantId || "",
          Len: Number(payload.len),
          // 持卡人姓名
          cardHolderName: payload.cardHolderName || "",
        },
      };
    }

    // 如果是跳转三方页面支付
    if (
      (checkoutStore.currentPayInfo as any).integrationType === INTEGRATION_TYPE.HOSTED_CHECKOUT
    ) {
      // 如果没有URL，则跳转到订单列表
      if (!url) {
        onPayError();
        return;
      }
      // 否则打开三方页面
      toPay(url);
      return;
    }

    // 如果是BNP信用卡表单支付
    if (checkoutStore.isBnpCreditCardForm) {
      // 如果缺少支付数据，则跳转到订单列表
      if (!(payload.actionUrl && payload.data && payload.merchantId && payload.len)) {
        onPayError();
        return;
      }

      creditCardStore.setBnpCreditCardSubmitForm({
        ...creditCardStore.bnpCreditCardSubmitForm,
        actionUrl: obj.url,
        ...obj.params,
      });

      setTimeout(() => {
        (document.getElementById("bnpSubmitForm") as HTMLFormElement).submit();
      }, 0);
      return;
    }

    onPayError();
  };

  const toPay = (url: string) => {
    window.location.href = url;
  };

  return (
    <Button
      variant="contained"
      fullWidth
      disabled={checkoutStore.submitOrderBtnDisabled || loading}
      onClick={handleSubmitOrder}
      className={Styles.commonBtn}
    >
      {t("checkout.common.placeOrderBtn")}
    </Button>
  );
});

export default CreditCardPay;
